<template>
  <v-dialog v-model="show" fullscreen :transition="false">
    <v-container fluid fill-height style="background-color: rgba(0, 0, 0, 0.8);">
      <v-layout justify-center align-center>
        <v-progress-circular :size="120" :width="6" color="accent" indeterminate></v-progress-circular>
        <div class="progressFiltro">
          <img src="@/assets/namoda.svg" class="ml-2" style="max-height: 76px " />
        </div>
      </v-layout>
    </v-container>
  </v-dialog>
</template>

<script>
export default {
  name: "waiting",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style>
</style>